export default __webpack_public_path__ + "static/media/bg-dark.8736da8f.jpg";